import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import "./UserTable.css";

const baseURL = process.env.REACT_APP_API_URL;


export default function UserTable() {
    const [userList, setUserList] = useState([]);
    const [newUserName, setNewUserName] = useState("");
    const [newUserProfile, setNewUserProfile] = useState("");

    useEffect(() => {
        fetch(`${baseURL}/usermanagement`)
            .then(res => res.json())
            .then(data => {
                const usersWithSelection = data.map(user => ({ ...user, selected: false }));
                setUserList(usersWithSelection);
            })
            .catch(err => console.error("Failed to load users:", err));
    }, []);

    const addUser = async () => {
        if (newUserName.trim() === "" || newUserProfile.trim() === "") {
            alert("Please enter both Name and Profile.");
            return;
        }

        const newUser = {
            name: newUserName,
            profile: newUserProfile,
            password: "default"
        };

        try {
            const res = await fetch(`${baseURL}/usermanagement`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(newUser)
            });

            if (!res.ok) {
                const errorData = await res.json();
                console.error("Failed to add user:", errorData.error);
                alert(`Failed to add user: ${errorData.error}`);
                return;
            }

            const addedUser = await res.json();
            setUserList([...userList, { ...addedUser, selected: false }]);

            setNewUserName("");
            setNewUserProfile("");
        } catch (err) {
            console.error("Failed to add user:", err);
        }
    };

    const removeSelectedUsers = async () => {
        const selectedUsers = userList.filter(user => user.selected);

        for (let user of selectedUsers) {
            await fetch(`${baseURL}/usermanagement/${user._id}`, {
                method: "DELETE"
            });
        }

        setUserList(userList.filter(user => !user.selected));
    };

    const toggleSelect = (index) => {
        const updated = [...userList];
        updated[index].selected = !updated[index].selected;
        setUserList(updated);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            addUser();
        }
    };

    return (
        <>
            <div className="user-table">
                <div className="user-row header">
                    <div className="cell">Users</div>
                    <div className="cell">Users' Profile</div>
                </div>

                {userList.map((user, index) => (
                    <div key={user._id} className="user-row">
                        <div className="cell checkbox">
                            <input
                                type="checkbox"
                                checked={user.selected}
                                onChange={() => toggleSelect(index)}
                            />
                        </div>
                        <div className={`cell ${user.selected ? "highlight" : ""}`}>
                            {user.name}
                        </div>
                        <div className={`cell ${user.selected ? "highlight" : ""}`}>
                            <Link to={`/user/${user.name}`} className="author-link">View Profile</Link>
                        </div>
                    </div>
                ))}

                <div className="user-row">
                    <div className="cell checkbox"></div>
                    <div className="cell">
                        <input
                            type="text"
                            placeholder="Enter name"
                            value={newUserName}
                            onChange={(e) => setNewUserName(e.target.value)}
                            onKeyDown={handleKeyDown}
                            className="user-input"
                        />
                    </div>
                    <div className="cell">
                        <input
                            type="text"
                            placeholder="Enter profile"
                            value={newUserProfile}
                            onChange={(e) => setNewUserProfile(e.target.value)}
                            onKeyDown={handleKeyDown}
                            className="user-input"
                        />
                    </div>
                </div>

                <div className="user-actions">
                    <button className="add-user" onClick={addUser}>Add User</button>
                    <button className="remove-user" onClick={removeSelectedUsers}>Remove User</button>
                </div>
            </div>
        </>
    );
}
